import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import ReactDOMServer from 'react-dom/server';
import {
  PText,
  PImage,
  PBlock,
  PContainer,
  PForm,
  PInput,
  PIcon,
  PButton,
  PMap,
  PVideo,
} from '../../components/editor/elements';


export class EditorBlockContainer extends React.Component {
  static propTypes = {
    block: PropTypes.shape({
      urlsafe: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      content: PropTypes.object.isRequired,
      localedits: PropTypes.number.isRequired,
      synctill: PropTypes.number.isRequired,
    }).isRequired,
    font: PropTypes.object.isRequired,
    color: PropTypes.object.isRequired,
    onBlockUpdate: PropTypes.func.isRequired,
    onElementDelete: PropTypes.func.isRequired,
    onBlockSync: PropTypes.func.isRequired,
    onInvokeGallery: PropTypes.func.isRequired,
    onInvokeIconChooser: PropTypes.func.isRequired,
    srcForMedia: PropTypes.func.isRequired,
  };

  componentDidUpdate(prevProps) {
    const { localedits, synctill } = this.props.block;
    if (localedits > prevProps.block.localedits) {
      if (localedits > synctill) {
        this.throttleSyncBlock();
      }
    }
  }

  throttleSyncBlock = throttle(() => {
    const { content, localedits } = this.props.block;
    this.props.onBlockSync(content, localedits);
  }, 7000, {
    leading: false,
    trailing: true,
  });

  components = {
    PText,
    PImage,
    PBlock,
    PContainer,
    PIcon,
    PButton,
    PMap,
    PVideo,
    PForm,
    PInput,
    div: 'div',
    span: 'span',
    p: 'p',
    form: 'form',
    label: 'label',
    input: 'input',
    button: 'button',
    textarea: 'textarea',
  };

  createChild = (c, pageProps, parentAddress, index, arrayContext = false) => {
    if (c == null) {
      return null;
    }
    if (Array.isArray(c)) {
      return c.map((child, i) => this.createChild(child, pageProps, parentAddress, i, true));
    }
    if (
      typeof c === 'boolean' ||
      typeof c === 'number' ||
      typeof c === 'string'
    ) {
      return c;
    }
    if (c.type) {
      return this.createFromObject(c, pageProps, parentAddress, index, arrayContext);
    }
    return null;
  };

  createReactElement = (component, pageProps, address, props = {}, key = null) => {
    const keyProp = (key !== null) ? { key } : {};
    const comboProps = pageProps.publish ? {
      ...props,
    } : {
      ...props,
      address,
      ...keyProp,
    };
    if (typeof component === 'function') {
      Object.assign(comboProps, pageProps);
      comboProps.updateNode = (address, updatedProps) => this.props.onBlockUpdate(address, updatedProps);
      comboProps.invokeGallery = (address, selectedProp, renderSize) => this.props.onInvokeGallery(address, selectedProp, renderSize);
      comboProps.invokeIconChooser = (address, selectedProp) => this.props.onInvokeIconChooser(address, selectedProp);
      comboProps.deleteElement = (address) => this.props.onElementDelete(address);
      comboProps.srcForMedia = (mediaUrlsafe, renderSize) => this.props.srcForMedia(mediaUrlsafe, renderSize);
    }
    return React.createElement(component, { ...comboProps });
  };

  // Recursively inflates a dictionary to react component
  // in a manner similar to babel compiler.
  // Each node also receives a hierarchical address
  // and page-wide properties
  createFromObject = (tree, pageProps, parentAddress = [], index = 0, arrayContext = false) => {
    const component = this.components[tree.type];
    const address = Object.assign([], parentAddress);
    address.push(index);

    if (!tree.props) {
      return this.createReactElement(component, pageProps, address);
    }

    const { children, ...props } = tree.props;
    if (children != null) {
      props.children = this.createChild(children, pageProps, address, 0);
    }

    return this.createReactElement(component, pageProps, address, props, arrayContext ? index : null);
  };

  getBlockHtml = () => {
    const { block, font, color } = this.props;
    const { content } = block;
    const pageProps = {
      fontScheme: font,
      colorScheme: color,
      publish: true,
    };
    const blockElement = content ? this.createFromObject(content, pageProps) : null;
    return ReactDOMServer.renderToString(blockElement);
  }

  render() {
    const { block, font, color } = this.props;
    const { content } = block;
    const pageProps = {
      fontScheme: font,
      colorScheme: color,
      publish: false,
    };

    // console.log(typeof content);
    // console.log(content);

    // const debug = false;
    // if (debug) {
    //   return (<pre style={{ fontSize: '10px' }}>{JSON.stringify(content, null, 2)}</pre>);
    // }

    return (
      content ? this.createFromObject(content, pageProps) : null
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/EditorBlockContainer.jsx